<div
    class="tw-flex tw-items-center tw-gap-5 tw-h-full tw-p-5 tw-relative tw-justify-evenly"
>
    <button
        (click)="closeDialog()"
        class="tw-absolute tw-right-4 tw-top-4 tw-text-black tw-text-2xl tw-z-10"
        aria-label="Close dialog"
    >
        ✕
    </button>
    <div
        class="tw-flex tw-flex-col tw-gap-2 tw-items-center tw-text-center tw-flex-1 tw-max-w-[257px]"
    >
        <h3 class="!tw-text-2xl !tw-font-bold">
            {{ "PROFILE.REFER.TITLE" | translate }}
        </h3>
        <p class="!tw-text-[#2B2B2BCC] !tw-max-w-[177px]">
            {{ "PROFILE.REFER.DESCRIPTION" | translate }}
        </p>
        <div
            class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded tw-border tw-border-gray-200 tw-p-2 tw-w-full"
        >
            <span class="tw-font-semibold tw-uppercase">{{
                data.referralCode
            }}</span>
            <button
                *ngIf="!copied"
                (click)="copyReferralCode()"
                class="tw-bg-[#0A0A75] tw-rounded-xl tw-text-white tw-py-[9px] tw-px-5 tw-w-full"
            >
                {{ "PROFILE.REFER.COPY_BUTTON" | translate }}
            </button>
            <mat-icon *ngIf="copied" class="tw-text-green-600">check</mat-icon>
        </div>
    </div>
    <div class="">
        <svg
            width="250"
            height="205"
            viewBox="0 0 250 205"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M212.315 95.0376V204H22.2412V95.0376C22.2412 93.5145 22.2726 91.9918 22.3557 90.4896C22.3661 90.1348 22.387 89.7805 22.4079 89.4362C23.1588 76.3558 26.5594 64.0055 32.0877 52.8752C33.1933 50.6534 34.3721 48.4839 35.634 46.3661C35.8739 45.9591 36.1137 45.5735 36.364 45.1664C36.8959 44.3215 37.4383 43.4766 37.9912 42.6317C38.2832 42.1938 38.5858 41.7449 38.8779 41.3071C39.1595 40.9005 39.4412 40.5039 39.7333 40.0969C39.7855 40.0238 39.8377 39.9406 39.8999 39.8675C40.6613 38.7723 41.4644 37.7084 42.2889 36.665C42.6228 36.248 42.9462 35.82 43.2796 35.4031C43.6971 34.8816 44.1245 34.3705 44.5525 33.859C45.5954 32.628 46.6593 31.4079 47.765 30.2395C47.9317 30.0623 48.0989 29.8847 48.2655 29.7076C49.1523 28.7686 50.0494 27.851 50.967 26.9852C51.1337 26.8081 51.2904 26.6513 51.4571 26.516C51.5198 26.4324 51.593 26.3702 51.6552 26.3075C52.8758 25.1391 54.1273 24.0126 55.4001 22.9069C57.3925 21.1962 59.4471 19.569 61.5753 18.0354C61.8256 17.8478 62.0759 17.6702 62.3366 17.493C64.0056 16.3038 65.7163 15.1668 67.4688 14.0925C71.8497 11.3806 76.4604 9.03338 81.2797 7.0619C83.0426 6.33193 84.8365 5.66415 86.6517 5.04862C86.9229 4.94413 87.2045 4.85058 87.4862 4.77743C88.7172 4.3704 89.9582 3.98476 91.2206 3.62997C99.4922 1.26191 108.234 0 117.267 0C125.497 0 133.477 1.04297 141.081 3.01445L141.915 3.23339C142.385 3.35829 142.854 3.48368 143.313 3.62997C146.714 4.58984 150.041 5.7368 153.275 7.0619C155.757 8.07352 158.188 9.20008 160.555 10.4102C161.296 10.7964 162.026 11.182 162.756 11.5786C163.591 12.0374 164.415 12.5071 165.239 12.9868C165.573 13.1744 165.896 13.3625 166.219 13.5605C166.511 13.7377 166.793 13.9049 167.074 14.0925C168.117 14.7184 169.14 15.3753 170.141 16.0639C171.289 16.8148 172.426 17.6075 173.531 18.4315C176.274 20.4448 178.914 22.6143 181.428 24.9197C181.699 25.1595 181.97 25.4098 182.231 25.6601C182.992 26.3697 183.733 27.0892 184.473 27.8296L184.692 28.0486C185.13 28.4969 185.579 28.9457 186.017 29.4045C186.309 29.7175 186.601 30.0305 186.872 30.3435C188.051 31.585 189.167 32.8574 190.262 34.1611C190.742 34.7348 191.222 35.319 191.692 35.9136C193.966 38.7927 196.093 41.8071 198.033 44.9365C198.179 45.1659 198.326 45.3953 198.461 45.6247C198.826 46.2193 199.18 46.8244 199.535 47.4295C199.932 48.1177 200.317 48.8063 200.693 49.495C200.798 49.6826 200.902 49.8603 200.996 50.0479C201.382 50.7569 201.757 51.4769 202.112 52.2069C202.519 52.9996 202.904 53.8027 203.28 54.6058C204.959 58.1313 206.409 61.7722 207.63 65.5271C207.703 65.767 207.786 65.9963 207.849 66.2367C207.88 66.3203 207.911 66.4034 207.932 66.4974C209.445 71.254 210.571 76.1772 211.312 81.2258C211.708 83.99 211.99 86.7855 212.157 89.6123C212.167 89.8835 212.188 90.1651 212.199 90.4363C212.24 91.3022 212.272 92.1575 212.282 93.0338C212.293 93.4926 212.303 93.9623 212.303 94.4211C212.315 94.6306 212.315 94.8291 212.315 95.0376Z"
                fill="#8F74FF"
            />
            <path
                d="M249.686 60.4493L228.416 68.2929L241.013 87.1454L219.187 80.9787L218.314 103.642L204.282 85.8163L190.249 103.642L189.377 80.9787L167.551 87.1449L180.148 68.2929L158.877 60.4493L180.148 52.6052L167.551 33.7532L189.377 39.9194L190.249 17.2568L204.282 35.0823L218.314 17.2568L219.187 39.9199L241.013 33.7537L228.416 52.6052L249.686 60.4493Z"
                fill="#FF8BC9"
            />
            <path
                d="M158.906 203.947H64.3568C61.5091 203.947 59.2002 201.638 59.2002 198.79V28.9979C59.2002 26.1502 61.5091 23.8413 64.3568 23.8413H158.906C161.755 23.8413 164.063 26.1502 164.063 28.9979V198.79C164.063 201.638 161.754 203.947 158.906 203.947Z"
                fill="#D3C3FC"
            />
            <path
                d="M162.653 203.947H68.1039C65.2561 203.947 62.9473 201.638 62.9473 198.79V28.9979C62.9473 26.1502 65.2561 23.8413 68.1039 23.8413H162.653C165.502 23.8413 167.81 26.1502 167.81 28.9979V198.79C167.81 201.638 165.502 203.947 162.653 203.947Z"
                fill="#0B0704"
            />
            <path
                d="M161.681 30.9913H69.0742V188.967H161.681V30.9913Z"
                fill="#FFB26F"
            />
            <path
                d="M124.912 199.987H105.846C103.899 199.987 102.315 198.403 102.315 196.456C102.315 194.51 103.899 192.926 105.846 192.926H124.912C126.858 192.926 128.442 194.51 128.442 196.456C128.442 198.403 126.858 199.987 124.912 199.987ZM105.846 193.177C104.037 193.177 102.566 194.647 102.566 196.456C102.566 198.265 104.037 199.736 105.846 199.736H124.912C126.721 199.736 128.191 198.265 128.191 196.456C128.191 194.647 126.721 193.177 124.912 193.177H105.846Z"
                fill="#FAF3EA"
            />
            <path
                d="M39.2704 63.2741C46.6771 60.1049 50.1122 51.5315 46.943 44.1248C43.7737 36.7182 35.2003 33.2831 27.7937 36.4523C20.3871 39.6215 16.952 48.1949 20.1212 55.6016C23.2904 63.0082 31.8638 66.4433 39.2704 63.2741Z"
                fill="#FFB26F"
            />
            <path
                d="M46.6037 49.5015L56.6731 59.1763L43.7764 55.9468L46.6037 49.5015Z"
                fill="#FFB26F"
            />
            <path
                d="M25.8507 45.0773C28.5203 41.4165 32.7355 45.9904 33.3679 46.7149C34.0004 45.9899 38.216 41.416 40.8851 45.0773C43.6941 48.9292 33.7212 57.768 33.147 58.2716C33.147 58.2835 33.1465 58.296 33.1465 58.296C33.1465 58.296 33.137 58.2875 33.1331 58.2835C33.1286 58.2875 33.1191 58.296 33.1191 58.296C33.1191 58.296 33.1196 58.2835 33.1196 58.2716C32.5678 57.7646 23.0428 48.9282 25.8507 45.0773Z"
                fill="#F34919"
            />
            <path
                d="M225.872 123.136H182.481V161.294H225.872V123.136Z"
                fill="#FFB26F"
            />
            <path
                d="M209.257 123.136H206.789V161.293H209.257V123.136Z"
                fill="#FFECF9"
            />
            <path
                d="M225.872 140.529H186.938V142.988H225.872V140.529Z"
                fill="#FFECF9"
            />
            <path
                d="M182.481 161.297H188.789V123.138H182.481V161.297Z"
                fill="#0B0704"
            />
            <mask
                id="mask0_18147_144790"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="14"
                y="25"
                width="218"
                height="164"
            >
                <path
                    d="M231.799 25.647H14.0273V188.967H231.799V25.647Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_18147_144790)">
                <path
                    d="M201.85 98.0119C205.695 96.0887 208.748 92.6364 210.186 88.5854C210.466 87.7977 210.688 86.9787 210.707 86.1427C210.742 84.6066 210.047 83.07 208.87 82.0828C207.693 81.0956 206.059 80.6776 204.552 80.9796C202.554 81.3797 200.987 82.9088 199.693 84.4837C198.495 85.9427 197.363 87.7634 197.792 89.6025"
                    fill="#FFEED1"
                />
                <path
                    d="M160.576 101.321L170.776 115.786L194.912 88.5715L205.397 95.5304C205.397 95.5304 187.614 142.628 170.775 142.628C158.204 142.628 140.677 112.056 140.677 112.056"
                    fill="#FFEED1"
                />
                <path
                    d="M122.96 80.897C122.96 80.897 138.803 78.7454 149.414 86.6323C160.025 94.5193 170.776 112.705 170.776 112.705L139.533 131.452L122.96 108.822"
                    fill="#003A70"
                />
                <path
                    d="M198.369 69.9573C200.35 72.5985 205.66 77.5083 208.221 79.5933C210.017 81.0562 212.448 82.0554 214.048 83.7293C215.316 85.0554 214.864 85.4206 213.521 86.4551C211.735 87.831 209.706 88.9376 207.616 89.7761C207.233 89.9303 206.824 90.0776 206.415 90.0174C206.05 89.9637 205.731 89.7507 205.434 89.5313C204.008 88.4729 202.816 87.1348 201.675 85.7744C198.788 82.3345 193.147 76.1703 190.783 72.3512"
                    fill="#0B0704"
                />
                <path
                    d="M185.035 76.0451C187.139 78.6276 190.786 79.1396 193.181 77.1886C195.576 75.2375 195.811 71.5622 193.708 68.9802C191.604 66.3977 187.957 65.8856 185.562 67.8367C183.167 69.7873 182.932 73.4626 185.035 76.0451Z"
                    fill="#0B0704"
                />
                <path
                    d="M195.456 77.6754L201.968 72.6377L191.606 59.4603L184.765 65.4275C184.077 66.0281 184.16 66.9646 184.606 67.7617C186.924 71.9003 189.456 75.3392 193.122 77.5161C193.907 77.9829 194.767 78.276 195.456 77.6754Z"
                    fill="#D3C3FC"
                />
                <path
                    d="M194.288 68.1149C197.218 71.712 200.716 73.7149 202.098 72.5883C203.482 71.4617 202.227 67.6317 199.297 64.0346C196.367 60.4375 192.869 58.4346 191.487 59.5612C190.103 60.6883 191.358 64.5178 194.288 68.1149Z"
                    fill="#7F60FF"
                />
                <path
                    d="M223.191 65.7917C223.191 65.7917 209.01 68.6449 202.021 71.3986C199.467 71.9858 196.621 68.9535 195.176 67.1462C191.447 62.4817 191.951 60.4983 191.951 60.4983C197.568 53.7917 202.096 39.9868 202.096 39.9868"
                    fill="#0B0704"
                />
                <path
                    d="M207.724 56.9092C214.56 65.2713 223.786 69.0391 228.33 65.324C232.875 61.609 231.017 51.8187 224.181 43.4566C217.345 35.0945 208.119 31.3267 203.575 35.0418C199.031 38.7563 200.888 48.547 207.724 56.9092Z"
                    fill="#7F60FF"
                />
                <path
                    d="M209.732 55.3143C215.514 62.3871 223.122 65.733 226.725 62.7877C230.328 59.8424 228.561 51.7211 222.779 44.6483C216.998 37.5754 209.39 34.2296 205.787 37.1749C202.184 40.1202 203.95 48.2414 209.732 55.3143Z"
                    fill="#FFB26F"
                />
                <path
                    d="M220.069 51.9435C216.798 54.6181 214.551 57.2419 213.241 58.97C212.032 57.9012 210.847 56.6791 209.732 55.3147C208.616 53.9498 207.654 52.5461 206.847 51.1483C208.801 50.2084 211.819 48.5285 215.091 45.8539L220.069 51.9435Z"
                    fill="#0B0704"
                />
                <path
                    d="M215.921 50.2562C217.309 51.9545 219.178 52.7233 220.095 51.9739C221.012 51.224 220.63 49.2396 219.242 47.5413C217.854 45.843 215.985 45.0742 215.068 45.8236C214.151 46.573 214.532 48.5579 215.921 50.2562Z"
                    fill="white"
                />
                <path
                    d="M193.306 91.7922C193.732 87.7935 195.14 83.868 197.701 80.8829C199.956 78.2556 202.195 75.9542 205.641 76.2851C206.111 76.3304 206.695 76.5638 206.677 77.0355C206.665 77.3241 206.418 77.541 206.185 77.7137C204.564 78.9194 202.98 80.552 202.496 82.5857C202.245 83.6356 202.331 84.7333 202.245 85.8091C202.023 88.5892 200.592 91.2513 198.396 92.97"
                    fill="#FFEED1"
                />
                <path
                    d="M212.241 82.2486C212.275 81.5574 212.475 81.0245 212.253 80.3687C212.163 80.1009 211.815 79.7482 211.593 79.5725C211.349 79.3789 211.012 79.3337 210.706 79.3899C210.399 79.4466 210.118 79.5944 209.852 79.7566C208.684 80.4672 207.669 81.5738 207.457 82.9238C207.444 83.0079 207.435 83.0975 207.468 83.1761C207.496 83.2428 207.552 83.294 207.61 83.3368C207.95 83.5851 208.399 83.7105 208.82 83.7105C209.803 83.7105 211.46 82.0709 211.578 81.8127"
                    fill="#FFEED1"
                />
                <path
                    d="M210.728 80.6633C210.762 79.9721 210.665 79.2745 210.443 78.6186C210.353 78.3509 210.233 78.0782 210.011 77.9026C209.767 77.709 209.43 77.6637 209.124 77.72C208.817 77.7767 208.536 77.9245 208.27 78.0867C207.102 78.7973 206.087 79.9039 205.875 81.2539C205.862 81.338 205.853 81.4271 205.886 81.5057C205.914 81.5729 205.97 81.6241 206.028 81.6669C206.368 81.9152 206.834 81.9341 207.238 81.8177C207.643 81.7012 208.001 81.4659 208.352 81.234C208.738 80.9792 209.124 80.7245 209.51 80.4697C209.747 80.3129 209.996 80.1428 210.115 79.884"
                    fill="#FFEED1"
                />
                <path
                    d="M209.146 78.9938C209.18 78.3026 209.083 77.605 208.861 76.9492C208.771 76.6814 208.651 76.4088 208.429 76.2331C208.185 76.0396 207.848 75.9938 207.542 76.0505C207.235 76.1072 206.954 76.255 206.688 76.4172C205.52 77.1278 204.505 78.2344 204.293 79.5849C204.28 79.669 204.271 79.7581 204.304 79.8367C204.332 79.9039 204.388 79.9551 204.446 79.9979C204.786 80.2462 205.252 80.2651 205.656 80.1487C206.061 80.0323 206.419 79.7969 206.77 79.565C207.156 79.3103 207.542 79.0555 207.928 78.8002C208.165 78.6435 208.414 78.4733 208.533 78.215"
                    fill="#FFEED1"
                />
                <path
                    d="M207.563 77.3239C207.597 76.6327 207.5 75.9351 207.278 75.2793C207.188 75.0116 207.068 74.7389 206.846 74.5632C206.602 74.3697 206.265 74.3244 205.958 74.3806C205.652 74.4373 205.371 74.5851 205.105 74.7473C203.937 75.4579 202.922 76.5646 202.71 77.9145C202.697 77.9986 202.688 78.0877 202.721 78.1663C202.749 78.233 202.804 78.2848 202.863 78.3276C203.203 78.5759 203.669 78.5948 204.073 78.4783C204.478 78.3619 204.836 78.1265 205.187 77.8946C205.573 77.6399 205.959 77.3851 206.345 77.1303C206.582 76.9736 206.831 76.8034 206.95 76.5447"
                    fill="#FFEED1"
                />
                <path
                    d="M202.088 84.0781C202.088 84.0781 202.072 90.8892 199.99 92.9707"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M122.879 162.94C122.879 162.94 125.331 181.736 122.879 198.898C120.428 216.059 89.8805 324.919 89.8805 324.919H57.3516L75.383 201.797C75.383 201.797 74.0062 183.098 85.0762 167.199"
                    fill="#464646"
                />
                <path
                    d="M148.629 167.199C148.629 167.199 150.049 192.444 149.068 220.19C147.443 266.143 139.72 324.919 139.72 324.919H108.885L110.368 205.197C110.368 205.197 103.907 176.989 110.173 164.03"
                    fill="#464646"
                />
                <path
                    d="M109.787 253.969C109.787 253.969 120.495 199.961 123.969 177.311"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M126.753 177.311L124.411 191.458C124.134 192.637 123.295 193.604 122.167 194.043L121.152 194.438"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M62.3633 324.919L82.821 201.355C82.821 201.355 81.5755 184.199 88.9509 174.206"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M101.454 177.387C101.454 177.387 98.443 183.24 95.6634 184.198C92.8844 185.156 83.751 187.289 83.751 187.289"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M148.863 187.289C148.863 187.289 141.611 185.157 139.562 184.198C136.96 182.982 136.744 176.247 136.744 176.247"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M134.016 84.8688C134.016 84.8688 146.933 94.6302 148.862 120.616C150.727 145.732 151.246 175.547 151.246 175.547C120.888 185.05 75.7285 175.221 75.7285 175.221C75.7285 175.221 83.6557 108.977 96.027 89.4059L118.11 79.4022L134.016 84.8688Z"
                    fill="#003A70"
                />
                <path
                    d="M115.273 80.7259C115.273 80.7259 94.6856 79.5068 85.7348 88.4576C76.784 97.4084 71.0303 108.822 71.0303 108.822L93.5257 127.797L105.497 106.915"
                    fill="#003A70"
                />
                <path
                    d="M93.5254 127.797L106.16 109.634"
                    stroke="#060606"
                    stroke-width="1.5136"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M130.809 80.8816C130.336 81.3548 131.952 88.5715 120.592 88.5715C109.684 88.5715 106.848 81.1379 106.848 81.1379"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M149.496 125.474L146.868 98.6379"
                    stroke="#060606"
                    stroke-width="1.5136"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M142.698 44.177C146.167 49.5261 152.386 63.5763 140.252 70.2521C128.576 76.6761 128.669 78.554 127.678 82.2626L110.619 80.9484C110.619 80.9484 112.884 73.264 112.36 67.7198C111.836 62.1756 108.803 55.866 113.808 47.6373C118.813 39.4085 135.978 33.8105 142.698 44.177Z"
                    fill="#FFEED1"
                />
                <path
                    d="M123.759 57.2141L124.983 49.0634C124.983 49.0634 132.131 50.0895 138.972 45.0239C138.972 45.0239 145.784 47.0302 150.579 41.902C155.374 36.7742 155.111 25.947 148.211 26.9079C143.486 27.5662 141.752 31.2987 141.752 31.2987C141.752 31.2987 138.301 26.4282 132.239 32.065C130.33 33.8404 128.6 35.4491 127.126 36.82C127.126 36.82 112.755 33.4652 107.506 41.4327C102.257 49.4003 108.251 55.9969 109.616 59.6762C110.982 63.3554 112.433 69.0643 112.433 69.0643C112.433 69.0643 118.995 69.0559 121.682 64.3999L123.759 57.2141Z"
                    fill="#312D2D"
                />
                <path
                    d="M132.555 48.1639C133.698 47.6882 134.798 47.1672 135.844 46.4975C136.899 45.8222 137.882 45.0256 138.778 44.1518C139.668 43.285 140.47 42.3311 141.17 41.3055C141.942 40.1745 142.625 38.9285 142.807 37.5522C142.878 37.0128 142.87 36.4102 142.52 35.9618C142.196 35.5473 141.673 35.4254 141.175 35.5478C139.978 35.8429 139.346 37.1242 138.935 38.1717C138.441 39.4311 137.903 40.8492 137.996 42.2241C138.073 43.3735 138.646 44.3623 139.559 45.0534C142.081 46.9617 145.302 45.9143 147.928 44.837C148.233 44.7116 148.11 44.2115 147.789 44.3309C145.606 45.141 143.097 46.1367 140.806 45.1455C139.927 44.7653 139.125 44.112 138.752 43.2103C138.259 42.0171 138.628 40.694 139.015 39.5276C139.363 38.4822 139.723 37.1979 140.592 36.4525C140.934 36.1589 141.536 35.8429 141.964 36.1524C142.431 36.4898 142.339 37.2476 142.255 37.7368C142.049 38.9335 141.447 40.0212 140.784 41.0224C140.166 41.9559 139.463 42.8332 138.69 43.6422C136.965 45.4465 134.819 47.0214 132.506 47.9838C132.395 48.0296 132.444 48.2102 132.555 48.1639Z"
                    fill="#060606"
                />
                <path
                    d="M127.28 36.4481C124.384 34.4527 120.904 33.264 117.374 33.2401C114.199 33.2187 111.002 34.1825 108.452 36.0948C107.07 37.1308 105.869 38.44 105.057 39.9716C104.962 40.1497 105.214 40.2935 105.326 40.1283C107.025 37.6259 109.477 35.7122 112.326 34.6861C115.403 33.5785 118.773 33.5964 121.902 34.4861C123.724 35.0041 125.468 35.7977 127.076 36.7974C127.299 36.9362 127.492 36.5944 127.28 36.4481Z"
                    fill="#060606"
                />
                <path
                    d="M123.759 57.214C123.759 57.214 120.62 52.5724 117.443 55.6117C114.266 58.6516 117.865 64.8805 123.004 64.4331L123.759 57.214Z"
                    fill="#FFEED1"
                />
                <path
                    d="M118.827 56.5865C120.251 57.7494 121.479 59.1522 122.443 60.7176L118.827 56.5865Z"
                    fill="#FFEED1"
                />
                <path
                    d="M118.827 56.5865C120.251 57.7494 121.479 59.1522 122.443 60.7176"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M132.695 53.0099C133.652 51.3589 135.441 50.2189 137.341 50.0487"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M145.242 52.2202C144.723 50.8607 143.328 49.8844 141.872 49.8625"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M139.837 56.4581C140.421 56.9224 140.916 57.4971 141.288 58.143C141.443 58.4107 141.578 58.6968 141.617 59.0033C141.711 59.7393 141.245 60.4225 140.76 60.9843"
                    stroke="#060606"
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                />
                <path
                    d="M136.48 60.5077C135.815 62.5513 136.128 64.2397 138.291 64.6656C139.364 64.8771 141.28 63.8884 141.909 62.103L136.48 60.5077Z"
                    fill="#EF92B5"
                />
                <path
                    d="M136.322 58.1164C136.287 58.1164 136.251 58.1149 136.216 58.112C135.531 58.0542 135.023 57.4526 135.081 56.7679L135.212 55.209C135.269 54.5243 135.872 54.0192 136.556 54.0734C137.24 54.1312 137.748 54.7328 137.691 55.4175L137.56 56.9764C137.505 57.6263 136.961 58.1164 136.322 58.1164Z"
                    fill="#060606"
                />
                <path
                    d="M142.951 57.7234C142.917 57.7234 142.882 57.7219 142.847 57.7189C142.162 57.6622 141.654 57.0611 141.71 56.3764L141.841 54.816C141.898 54.1313 142.498 53.6222 143.185 53.6804C143.869 53.7382 144.378 54.3398 144.32 55.0245L144.189 56.5824C144.136 57.2323 143.592 57.7234 142.951 57.7234Z"
                    fill="#060606"
                />
                <path
                    d="M109.354 80.7533C109.354 80.7533 111.31 86.6319 120.249 86.6319C129.189 86.6319 128.679 80.6702 128.679 80.6702L120.003 78.8605L109.354 80.7533Z"
                    fill="#FFEED1"
                />
            </g>
            <path
                d="M139.961 122.014H127.163V127.945V131.325V156.388C127.163 157.313 127.914 158.07 128.845 158.07H187.611C187.636 158.07 187.656 158.07 187.681 158.065C188.577 158.03 189.293 157.289 189.293 156.388V131.325V122.014H139.961Z"
                fill="#FFB26F"
            />
            <path
                d="M141.629 120.831H128.831V126.762V130.142V155.205C128.831 156.13 129.582 156.887 130.513 156.887H189.279C189.304 156.887 189.324 156.887 189.349 156.882C190.245 156.847 190.961 156.105 190.961 155.205V130.142V120.831H141.629Z"
                fill="#0B0704"
            />
            <path
                d="M190.961 120.831H128.831V125.822H190.961V120.831Z"
                fill="#D3C3FC"
            />
            <path
                d="M186.252 123.137C186.252 123.757 186.755 124.26 187.375 124.26C187.995 124.26 188.498 123.757 188.498 123.137C188.498 122.517 187.996 122.014 187.375 122.014C186.755 122.014 186.252 122.517 186.252 123.137Z"
                fill="#0B0704"
            />
            <path
                d="M182.26 123.137C182.26 123.757 182.762 124.26 183.383 124.26C184.003 124.26 184.506 123.757 184.506 123.137C184.506 122.517 184.003 122.014 183.383 122.014C182.762 122.014 182.26 122.517 182.26 123.137Z"
                fill="#7F60FF"
            />
            <path
                d="M178.205 123.137C178.205 123.757 178.708 124.26 179.328 124.26C179.948 124.26 180.451 123.757 180.451 123.137C180.451 122.517 179.949 122.014 179.328 122.014C178.708 122.014 178.205 122.517 178.205 123.137Z"
                fill="#FFECF9"
            />
            <path
                d="M135.71 145.649H182.59V133.58H135.71V145.649Z"
                fill="#F34919"
            />
            <path
                d="M127.214 144.885C127.214 144.885 146.374 147.823 146.389 148.867C146.404 149.912 142.049 151.051 142.049 151.051C142.049 151.051 138.842 155.226 131.843 155.845C124.844 156.465 83.193 154.656 83.193 154.656L81.2324 134.649C81.2324 134.649 120.933 140.307 127.214 140.986L127.214 144.885Z"
                fill="#FFEED1"
            />
            <path
                d="M141.89 150.813C138.331 151.595 134.674 151.866 131.035 151.868C130.752 151.868 130.754 152.295 131.035 152.308C134.726 152.474 138.396 152.004 141.985 151.159C142.21 151.105 142.115 150.764 141.89 150.813Z"
                fill="#382F30"
            />
            <path
                d="M140.104 152.749C136.971 153.45 133.802 153.765 130.593 153.767C130.278 153.767 130.282 154.238 130.593 154.253C133.819 154.411 137.102 154.004 140.21 153.131C140.456 153.062 140.353 152.693 140.104 152.749Z"
                fill="#382F30"
            />
            <path
                d="M71.8778 109.536C71.8778 109.536 53.1174 141.669 62.9464 148.494C72.7749 155.319 84.3829 154.702 84.3829 154.702L89.9202 135.882L84.7362 135.148L90.4974 125.242L71.8778 109.536Z"
                fill="#FFEED1"
            />
            <path
                d="M179.484 141.328L183.357 151.162L185.584 148.117L190.193 152.942L192.106 150.884L187.221 146.522L190.203 144.384L179.484 141.328Z"
                fill="#0B0704"
            />
            <path
                d="M180.019 139.995L183.769 149.518L185.996 146.475L190.605 151.299L192.519 149.241L187.632 144.879L190.615 142.741L180.218 139.776C180.086 139.739 179.968 139.868 180.019 139.995Z"
                fill="white"
            />
            <path
                d="M82.2033 100.877H47.5715C45.6781 100.877 44.1436 99.3422 44.1436 97.4489V77.5216C44.1436 75.6282 45.6786 74.0936 47.5715 74.0936H82.2033C84.0966 74.0936 85.6312 75.6287 85.6312 77.5216V97.4489C85.6312 99.3422 84.0966 100.877 82.2033 100.877Z"
                fill="#0B0704"
            />
            <path
                d="M84.3429 98.7114H49.7111C47.8178 98.7114 46.2832 97.1763 46.2832 95.2834V75.3562C46.2832 73.4628 47.8178 71.9282 49.7111 71.9282H84.3429C86.2363 71.9282 87.7709 73.4633 87.7709 75.3562V95.2834C87.7709 97.1763 86.2363 98.7114 84.3429 98.7114Z"
                fill="#FEC2F2"
            />
            <path
                d="M72.9142 75.6571H61.3555V87.2158H72.9142V75.6571Z"
                fill="white"
            />
            <path
                d="M62.1113 92.4286C65.6957 92.4286 68.6014 89.5228 68.6014 85.9384C68.6014 82.354 65.6957 79.4482 62.1113 79.4482C58.5268 79.4482 55.6211 82.354 55.6211 85.9384C55.6211 89.5228 58.5268 92.4286 62.1113 92.4286Z"
                fill="#7F60FF"
            />
            <path
                d="M63.9404 93.8687H78.432L70.8715 82.2408L63.9404 93.8687Z"
                fill="#F34919"
            />
            <path
                d="M0.549805 204L239.55 204"
                stroke="#060606"
                stroke-width="1.5136"
                stroke-miterlimit="10"
                stroke-linejoin="round"
            />
            <path
                d="M171.697 140.994C171.697 140.322 171.825 139.771 172.083 139.34C172.34 138.908 172.671 138.589 173.078 138.382C173.492 138.166 173.924 138.058 174.372 138.058V139.389C173.99 139.389 173.629 139.443 173.289 139.551C172.958 139.651 172.688 139.817 172.481 140.049C172.273 140.281 172.17 140.588 172.17 140.969L171.697 140.994ZM170.776 144.303V138.083H172.17V144.303H170.776Z"
                fill="white"
            />
            <path
                d="M166.699 144.452C166.093 144.452 165.554 144.316 165.081 144.042C164.617 143.76 164.248 143.374 163.974 142.885C163.709 142.396 163.576 141.832 163.576 141.193C163.576 140.555 163.713 139.991 163.987 139.501C164.26 139.012 164.634 138.631 165.106 138.357C165.587 138.075 166.135 137.934 166.748 137.934C167.304 137.934 167.802 138.079 168.241 138.369C168.689 138.651 169.046 139.062 169.311 139.601C169.576 140.14 169.709 140.783 169.709 141.529H168.303C168.303 140.99 168.237 140.546 168.104 140.198C167.98 139.85 167.797 139.593 167.557 139.427C167.325 139.253 167.039 139.166 166.699 139.166C166.342 139.166 166.035 139.244 165.778 139.402C165.521 139.559 165.326 139.792 165.193 140.099C165.061 140.397 164.994 140.774 164.994 141.231C164.994 141.637 165.073 141.985 165.231 142.275C165.397 142.566 165.616 142.79 165.89 142.947C166.172 143.097 166.483 143.171 166.823 143.171C167.196 143.171 167.503 143.088 167.744 142.922C167.984 142.748 168.171 142.528 168.303 142.263L169.585 142.81C169.411 143.142 169.187 143.432 168.913 143.681C168.648 143.93 168.328 144.121 167.955 144.253C167.59 144.386 167.171 144.452 166.699 144.452ZM164.497 141.529V140.422H168.975V141.529H164.497Z"
                fill="white"
            />
            <path
                d="M159.882 144.303V137.424C159.882 136.769 160.044 136.267 160.367 135.919C160.699 135.562 161.197 135.384 161.86 135.384C162.076 135.384 162.304 135.421 162.544 135.496C162.793 135.562 163.03 135.653 163.254 135.769L162.744 136.802C162.586 136.727 162.445 136.673 162.321 136.64C162.204 136.607 162.101 136.59 162.01 136.59C161.761 136.59 161.574 136.673 161.45 136.839C161.334 136.997 161.276 137.258 161.276 137.623V144.303H159.882ZM158.812 139.228V138.083H162.905V139.228H158.812Z"
                fill="white"
            />
            <path
                d="M155.181 144.452C154.576 144.452 154.037 144.316 153.564 144.042C153.099 143.76 152.73 143.374 152.457 142.885C152.191 142.396 152.059 141.832 152.059 141.193C152.059 140.555 152.195 139.991 152.469 139.501C152.743 139.012 153.116 138.631 153.589 138.357C154.07 138.075 154.617 137.934 155.231 137.934C155.786 137.934 156.284 138.079 156.724 138.369C157.171 138.651 157.528 139.062 157.793 139.601C158.059 140.14 158.191 140.783 158.191 141.529H156.786C156.786 140.99 156.719 140.546 156.587 140.198C156.462 139.85 156.28 139.593 156.039 139.427C155.807 139.253 155.521 139.166 155.181 139.166C154.824 139.166 154.518 139.244 154.26 139.402C154.003 139.559 153.808 139.792 153.676 140.099C153.543 140.397 153.477 140.774 153.477 141.231C153.477 141.637 153.556 141.985 153.713 142.275C153.879 142.566 154.099 142.79 154.372 142.947C154.654 143.097 154.965 143.171 155.305 143.171C155.679 143.171 155.985 143.088 156.226 142.922C156.466 142.748 156.653 142.528 156.786 142.263L158.067 142.81C157.893 143.142 157.669 143.432 157.395 143.681C157.13 143.93 156.811 144.121 156.437 144.253C156.073 144.386 155.654 144.452 155.181 144.452ZM152.979 141.529V140.422H157.458V141.529H152.979Z"
                fill="white"
            />
            <path
                d="M146.055 141.094V139.763H147.884C148.166 139.763 148.415 139.7 148.63 139.576C148.854 139.452 149.033 139.282 149.165 139.066C149.306 138.85 149.377 138.606 149.377 138.332C149.377 137.917 149.227 137.577 148.929 137.312C148.63 137.047 148.245 136.914 147.772 136.914H146.055V135.595L147.822 135.583C148.419 135.575 148.945 135.691 149.402 135.931C149.858 136.163 150.214 136.487 150.471 136.901C150.728 137.316 150.857 137.793 150.857 138.332C150.857 138.871 150.72 139.348 150.447 139.763C150.181 140.177 149.812 140.505 149.339 140.745C148.867 140.978 148.332 141.094 147.735 141.094H146.055ZM144.749 144.303V135.595H146.192V144.303H144.749ZM149.576 144.303L147.536 140.77L148.655 139.999L151.205 144.303H149.576Z"
                fill="white"
            />
        </svg>
    </div>
</div>
